// extracted by mini-css-extract-plugin
export default {"container":"NavigationButtons_container__F+X3p","previous":"NavigationButtons_previous__AG9KA","next":"NavigationButtons_next__HIArd","icon":"NavigationButtons_icon__wW6N5"};